
const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-slate-900 to-slate-800 text-white py-24">
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/ba7401ddfeafb209ffc3b2abc6b01846.jpg')`
        }}
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <h1 className="text-5xl font-bold mb-6">
            Global Commerce
            <span className="text-teal-400"> Insights</span>
          </h1>
          <p className="text-xl text-gray-300 mb-8 leading-relaxed">
            Expert insights, practical strategies, and the latest trends in international 
            e-commerce to help you navigate global expansion successfully.
          </p>
          <div className="flex flex-wrap gap-6 text-sm">
            <div className="flex items-center">
              <i className="ri-article-line text-teal-400 mr-2"></i>
              <span>Weekly Insights</span>
            </div>
            <div className="flex items-center">
              <i className="ri-global-line text-teal-400 mr-2"></i>
              <span>Global Market Updates</span>
            </div>
            <div className="flex items-center">
              <i className="ri-lightbulb-line text-teal-400 mr-2"></i>
              <span>Actionable Strategies</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
